import { FC, memo } from "react";
import { useCompanyFilterOptions } from "../../hooks";
import { SpendRowsFilter } from "../itSpend/ITSpendFilter";
import type { AiSpendOptions } from "./options";

export const AISpendFilter: FC = memo(() => {
  const options = useCompanyFilterOptions("aiSpend") as
    | AiSpendOptions
    | undefined;

  return (
    <SpendRowsFilter
      filterKey="aiSpend"
      categories={options?.aiSpendCategories ?? []}
      description="Add one or more AI spend budgets by category. Multiple rows are combined with AND."
      categoryLabel="AI spend category"
      categoryPlaceholder="Search AI spend categories"
      testIdPrefix="ai-spend-filter"
    />
  );
});

AISpendFilter.displayName = "AISpendFilter";
